import { Group, useMantineTheme } from '@mantine/core';
import { IconDatabasePlus } from '@tabler/icons-react';
import DeviceTypeList from 'components/DeviceTypeList';
import { EvidenceFieldRow } from 'components/tables/data/evidence-field/types';
import P2Medium from 'components/typography/P2Medium';

/**
 * Column for the evidence field device.
 */
export default function DeviceColumn({ data: { allDeviceTypes, deviceTypes = [] } }: { data: EvidenceFieldRow }) {
  const theme = useMantineTheme();

  if (allDeviceTypes) {
    return (
      <Group spacing={8}>
        <IconDatabasePlus stroke={2} color={theme.colors.red[8]} size={20} />
        <P2Medium color="gray.8">Všetky typy zariadení</P2Medium>
      </Group>
    );
  }

  return <DeviceTypeList deviceTypes={deviceTypes} limit={2} />;
}
